<ng-container *ngIf="period === 'DAY'; else NIGHT_TEMPLATE">
  <ng-container
    *ngIf="
      !isSurgeonOpeningsRoomsLayout &&
      !isCommissionRegulationLayout &&
      !isSmartPlanningDetailsLayout &&
      !isSmartPlanningSideColumnLayout &&
      !isTVO
    "
  >
    <ng-container *ngIf="separateMorningAfternoon; else combinedTotal">
      <div *ngIf="!isMensuel" [fxLayout]="layout" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div class="details-button" (click)="openDetailsPopup()" *ngIf="showInformationsButton && !showStatusIconOnly">
          <mat-icon>info_outline</mat-icon>
        </div>

        <!-- Container effective needs morning afternon split -->
        <div
          *ngIf="!showStatusIconOnly"
          class="normal-text"
          [class.clickable-text]="clickOnTextToOpenDetails"
          fxLayout="column"
          [fxLayoutAlign]="getFxLayoutAlign()"
          (click)="clickOnTextToOpenDetails ? openDetailsPopup() : undefined"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="label-full-width">Matin :&nbsp;</div>
            <div class="label-lesser-width">M :&nbsp;</div>

            @if (!isLoading) {
              <div *ngIf="!isTVO; else TVOMorning">
                {{ $any(totalNeedsEffectif).morning.effective }} / {{ $any(totalNeedsEffectif).morning.needs }}
              </div>
              <ng-template #TVOMorning>
                {{ $any(totalNeedsEffectif).morning.needs }}
              </ng-template>
              <div
                class="difference"
                *ngIf="showDifference"
                [class.green-text]="getDifference($any(totalNeedsEffectif).morning) >= 0"
                [class.red-text]="getDifference($any(totalNeedsEffectif).morning) < 0"
              >
                &nbsp; ({{
                  getDifference($any(totalNeedsEffectif).morning) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif).morning)
                    : getDifference($any(totalNeedsEffectif).morning)
                }})
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
            }
          </div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="label-full-width">Après-midi :&nbsp;</div>
            <div class="label-lesser-width">AM :&nbsp;</div>

            @if (!isLoading) {
              @if (!isTVO) {
                <div>
                  {{ $any(totalNeedsEffectif).afternoon.effective }} / {{ $any(totalNeedsEffectif).afternoon.needs }}
                </div>
              } @else {
                {{ $any(totalNeedsEffectif).afternoon.needs }}
              }
              @if (showDifference) {
                <div
                  class="difference"
                  [class.green-text]="getDifference($any(totalNeedsEffectif).afternoon) >= 0"
                  [class.red-text]="getDifference($any(totalNeedsEffectif).afternoon) < 0"
                >
                  &nbsp; ({{
                    getDifference($any(totalNeedsEffectif).afternoon) >= 0
                      ? '+' + getDifference($any(totalNeedsEffectif).afternoon)
                      : getDifference($any(totalNeedsEffectif).afternoon)
                  }})
                </div>
              }
            } @else {
              <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
            }
          </div>
        </div>
        <!-- Coverage percentage -->
        <!-- Print coverage percentage only out the bloc while visualizing a scenario -->
        @if (showCoveragePercentage && !isMensuel) {
          @if (isEffectiveNeedsByReasonMaps) {
            <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
              <p
                class="day-needs percentage-badge"
                [ngClass]="'percentage-' + coveragePercentage?.percentageLabel"
                fxLayout="row"
                fxLayoutAlign="center center"
              >
                {{ coveragePercentage?.percentage }}%
              </p>
            </div>
          } @else {
            @if (!isPastDate) {
              <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
                <p
                  class="day-needs percentage-badge"
                  [ngClass]="'percentage-' + coveragePercentage?.percentageLabel"
                  fxLayout="row"
                  fxLayoutAlign="center center"
                >
                  <span
                    class="percentage-value"
                    [class.anchor-right]="isOnRightSide()"
                    style="display: flex; align-items: center; gap: 5px"
                  >
                    <img src="../../../../assets/icons/idee-ampoule.png" alt="intelligent feature" height="16px" />
                    <span class="percentageCoverage">{{ coveragePercentage?.percentage }}%</span>
                    <span class="tooltip" [innerHTML]="coverageBySkillsText"></span>
                  </span>
                </p>
              </div>
            } @else {
              <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
                <app-objectif-status class="objectif-status" [isLoading]="isLoading" [status]="objectifStatus()">
                </app-objectif-status>
              </div>
            }
          }
        } @else if (!isMensuel && (showStatusIcon || showStatusIconOnly)) {
          <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
            <app-objectif-status class="objectif-status" [isLoading]="isLoading" [status]="objectifStatus()">
            </app-objectif-status>
          </div>
        }
      </div>
    </ng-container>

    <ng-template #combinedTotal>
      <div [fxLayout]="layout" fxLayoutAlign="start center" fxLayoutGap="10px">
        @if (showInformationsButton && !showStatusIconOnly) {
          <div class="details-button" (click)="openDetailsPopup()">
            <mat-icon>info_outline</mat-icon>
          </div>
        }

        <!-- Combined total -->
        <div
          *ngIf="!showStatusIconOnly"
          fxLayoutAlign="start center"
          [class.clickable-text]="clickOnTextToOpenDetails"
          class="normal-text"
          fxLayout="row"
          [fxLayoutAlign]="getFxLayoutAlign()"
          (click)="clickOnTextToOpenDetails ? openDetailsPopup() : undefined"
        >
          @if (!isLoading) {
            @if (isEffectiveNeedsByReasonMaps && dayNeeds !== undefined && dayEffectifs !== undefined) {
              @if (!minimalistTitle) {
                <div class="bilan">Bilan :&nbsp;</div>
              }
              <div class="bilan">{{ dayEffectifs }} / {{ dayNeeds }}</div>
              <!-- | number: '1.0-0' -->

              @if (showDifference) {
                <div
                  class="difference"
                  [class.green-text]="dayEffectifs - dayNeeds >= 0"
                  [class.red-text]="dayEffectifs - dayNeeds < 0"
                >
                  &nbsp; ({{
                    dayEffectifs - dayNeeds >= 0
                      ? '+' + formatNumber(dayEffectifs - dayNeeds)
                      : formatNumber(dayEffectifs - dayNeeds)
                  }})
                </div>
              }
            } @else {
              <div>{{ $any(totalNeedsEffectif).effective }} / {{ $any(totalNeedsEffectif).needs }}</div>

              <div
                class="difference"
                *ngIf="showDifference"
                [class.green-text]="getDifference($any(totalNeedsEffectif)) >= 0"
                [class.red-text]="getDifference($any(totalNeedsEffectif)) < 0"
              >
                &nbsp; ({{
                  getDifference($any(totalNeedsEffectif)) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif))
                    : getDifference($any(totalNeedsEffectif))
                }})
              </div>
            }
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>
        <!-- Coverage percentage -->
        @if (isEffectiveNeedsByReasonMaps && showCoveragePercentage && !isMensuel) {
          <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
            <p
              class="day-needs percentage-badge"
              [ngClass]="'percentage-' + coveragePercentage?.percentageLabel"
              fxLayout="row"
              fxLayoutAlign="center center"
            >
              {{ coveragePercentage?.percentage }}%
            </p>
          </div>
        } @else if (!isMensuel && (showStatusIcon || showStatusIconOnly)) {
          <div class="objectif-status-container" [class.height-32px]="layout === 'column'">
            <app-objectif-status class="objectif-status" [isLoading]="isLoading" [status]="objectifStatus()">
            </app-objectif-status>
          </div>
        }
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="isCommissionRegulationLayout">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div
        class="commission-regulation"
        fxLayout="row"
        fxLayoutAlign="start center"
        [class.clickable-text]="clickOnTextToOpenDetails"
        (click)="clickOnTextToOpenDetails ? openDetailsPopup() : undefined"
      >
        <div class="min-width-108px" fxLayout="row" fxLayoutAlign="start center">
          @if (!isLoading) {
            <div>{{ $any(totalNeedsEffectif).morning.effective }}/{{ $any(totalNeedsEffectif).morning.needs }}</div>

            <div
              class="difference"
              *ngIf="showDifference"
              [class.green-text]="getDifference($any(totalNeedsEffectif).morning) >= 0"
              [class.red-text]="getDifference($any(totalNeedsEffectif).morning) < 0"
            >
              &nbsp; ({{
                getDifference($any(totalNeedsEffectif).morning) >= 0
                  ? '+' + getDifference($any(totalNeedsEffectif).morning)
                  : getDifference($any(totalNeedsEffectif).morning)
              }})
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>

        @if (!isLoading) {
          <div>{{ $any(totalNeedsEffectif).afternoon.effective }}/{{ $any(totalNeedsEffectif).afternoon.needs }}</div>

          <div
            class="difference"
            *ngIf="showDifference"
            [class.green-text]="getDifference($any(totalNeedsEffectif).afternoon) >= 0"
            [class.red-text]="getDifference($any(totalNeedsEffectif).afternoon) < 0"
          >
            &nbsp; ({{
              getDifference($any(totalNeedsEffectif).afternoon) >= 0
                ? '+' + getDifference($any(totalNeedsEffectif).afternoon)
                : getDifference($any(totalNeedsEffectif).afternoon)
            }})
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
        }
      </div>

      <div class="objectif-status-container">
        <app-objectif-status class="objectif-status" [isLoading]="isLoading" [status]="objectifStatus()">
        </app-objectif-status>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isSmartPlanningSideColumnLayout">
    <div
      fxLayout="column"
      fxLayoutAlign="start space-between"
      class="smartplanning-side-column-style"
      (click)="openDetailsPopup()"
    >
      <div fxLayout="row" fxLayoutAlign="space-between center" class="margin-bottom-6px">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
          <div class="smartplanning-text">Matin</div>
        </div>

        @if (!isLoading) {
          <div fxLayout="row" fxLayoutAlign="center center">
            <div class="smartplanning-text-data">
              {{ $any(totalNeedsEffectif).morning.effective }} /
              {{ $any(totalNeedsEffectif).morning.needs }}
            </div>
            <div
              *ngIf="showDifference"
              fxLayout="row"
              fxLayoutAlign="center center"
              [class.green]="getDifference($any(totalNeedsEffectif).morning) >= 0"
              [class.yellow]="getDifference($any(totalNeedsEffectif).morning) < 0"
            >
              <span>{{
                getDifference($any(totalNeedsEffectif).morning) >= 0
                  ? '+' + getDifference($any(totalNeedsEffectif).morning)
                  : getDifference($any(totalNeedsEffectif).morning)
              }}</span>
            </div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
        }
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="margin-bottom-6px">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
          <div class="smartplanning-text">Après-midi</div>
        </div>

        @if (!isLoading) {
          <div fxLayout="row" fxLayoutAlign="center center">
            <div class="smartplanning-text-data">
              {{ $any(totalNeedsEffectif).afternoon.effective }} /
              {{ $any(totalNeedsEffectif).afternoon.needs }}
            </div>
            <div
              class="difference"
              fxLayout="row"
              fxLayoutAlign="center center"
              *ngIf="showDifference"
              [class.green]="getDifference($any(totalNeedsEffectif).afternoon) >= 0"
              [class.yellow]="getDifference($any(totalNeedsEffectif).afternoon) < 0"
            >
              <span>{{
                getDifference($any(totalNeedsEffectif).afternoon) >= 0
                  ? '+' + getDifference($any(totalNeedsEffectif).afternoon)
                  : getDifference($any(totalNeedsEffectif).afternoon)
              }}</span>
            </div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
        }
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isSmartPlanningDetailsLayout">
    <div
      fxLayout="column"
      fxLayoutAlign="start space-between"
      class="smartplanning-side-column-style"
      (click)="openDetailsPopup()"
    >
      <div fxLayout="column" fxLayoutAlign="start space-between" *ngIf="separateMorningAfternoon" class="body-recap">
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" class="margin-bottom-6px">
          <div class="smartplanning-text">Matin</div>
          <div fxLayout="row" fxLayoutAlign="center center">
            @if (!isLoading) {
              <div class="smartplanning-text-data">
                {{ $any(totalNeedsEffectif).morning.effective }} / {{ $any(totalNeedsEffectif).morning.needs }}
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                *ngIf="showDifference"
                [class.green]="getDifference($any(totalNeedsEffectif).morning) >= 0"
                [class.yellow]="getDifference($any(totalNeedsEffectif).morning) < 0"
              >
                <span>{{
                  getDifference($any(totalNeedsEffectif).morning) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif).morning)
                    : getDifference($any(totalNeedsEffectif).morning)
                }}</span>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
            }
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
          <div class="smartplanning-text">Après-midi</div>
          <div fxLayout="row" fxLayoutAlign="center center">
            @if (!isLoading) {
              <div class="smartplanning-text-data">
                {{ $any(totalNeedsEffectif).afternoon.effective }} / {{ $any(totalNeedsEffectif).afternoon.needs }}
              </div>
              <div
                fxLayout="row"
                fxLayoutAlign="center center"
                *ngIf="showDifference"
                [class.green]="getDifference($any(totalNeedsEffectif).afternoon) >= 0"
                [class.yellow]="getDifference($any(totalNeedsEffectif).afternoon) < 0"
              >
                <span>{{
                  getDifference($any(totalNeedsEffectif).afternoon) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif).afternoon)
                    : getDifference($any(totalNeedsEffectif).afternoon)
                }}</span>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
            }
          </div>
        </div>
      </div>
      <div class="body-recap" *ngIf="!separateMorningAfternoon" fxLayoutAlign="center center">
        @if (!isLoading) {
          <div>{{ $any(totalNeedsEffectif).effective }} / {{ $any(totalNeedsEffectif).needs }}</div>
          <div
            class="difference"
            *ngIf="showDifference"
            [class.green-text]="getDifference($any(totalNeedsEffectif)) >= 0"
            [class.red-text]="getDifference($any(totalNeedsEffectif)) < 0"
          >
            &nbsp; ({{
              getDifference($any(totalNeedsEffectif)) >= 0
                ? '+' + getDifference($any(totalNeedsEffectif))
                : getDifference($any(totalNeedsEffectif))
            }})
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
        }
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isSurgeonOpeningsRoomsLayout">
    <div
      class="h-full"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="10px"
      (mouseenter)="onEffectiveNeedsMouseEnter()"
      (mouseleave)="onEffectiveNeedsMouseLeave()"
    >
      <div
        class="min-width-440px nowrap h-full border-grey total-needs-effectif-text"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <div
          class="h-full border-right-grey"
          [class.background-white]="!isLoading && getDifference($any(totalNeedsEffectif).morning) >= 0"
          [class.background-warning]="!isLoading && getDifference($any(totalNeedsEffectif).morning) < 0"
          fxLayout="row"
          fxLayoutAlign="space-around center"
          fxFlex="45"
        >
          <div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
              <mat-icon *ngIf="!isLoading && getDifference($any(totalNeedsEffectif).morning) < 0" class="warning-color"
                >warning</mat-icon
              >
              <span>Matin :</span>
            </div>
          </div>
          @if (!isLoading) {
            <div>
              <span class="margin-right-10px"
                >{{ $any(totalNeedsEffectif).morning.effective }} / {{ $any(totalNeedsEffectif).morning.needs }}</span
              >
              <span
                [class.positive-needs-effectif]="getDifference($any(totalNeedsEffectif).morning) >= 0"
                [class.negative-needs-effectif]="getDifference($any(totalNeedsEffectif).morning) < 0"
              >
                {{
                  getDifference($any(totalNeedsEffectif).morning) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif).morning)
                    : getDifference($any(totalNeedsEffectif).morning)
                }}
              </span>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>
        <div
          class="h-full"
          [class.background-white]="!isLoading && getDifference($any(totalNeedsEffectif).afternoon) >= 0"
          [class.background-warning]="!isLoading && getDifference($any(totalNeedsEffectif).afternoon) < 0"
          fxLayout="row"
          fxLayoutAlign="space-around center"
          fxFlex="55"
        >
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <mat-icon *ngIf="!isLoading && getDifference($any(totalNeedsEffectif).afternoon) < 0" class="warning-color"
              >warning</mat-icon
            >
            <span>Après-midi :</span>
          </div>
          @if (!isLoading) {
            <div>
              <span class="margin-right-10px"
                >{{ $any(totalNeedsEffectif).afternoon.effective }} /
                {{ $any(totalNeedsEffectif).afternoon.needs }}</span
              >
              <span
                [class.positive-needs-effectif]="getDifference($any(totalNeedsEffectif).afternoon) >= 0"
                [class.negative-needs-effectif]="getDifference($any(totalNeedsEffectif).afternoon) < 0"
              >
                {{
                  getDifference($any(totalNeedsEffectif).afternoon) >= 0
                    ? '+' + getDifference($any(totalNeedsEffectif).afternoon)
                    : getDifference($any(totalNeedsEffectif).afternoon)
                }}
              </span>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>
      </div>
    </div>

    <div
      *ngIf="!isLoading"
      class="border-grey width-50vw min-width-600px display-none"
      [class.display-effective-needs-details]="hoverEffectiveNeeds"
      fxLayout="row"
    >
      <div fxFlex="50">
        <div fxLayout="column">
          <ng-container *ngFor="let item of details">
            <div
              class="border-right-grey height-28px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span class="so-title margin-left-10px">Matin</span>
              <span class="so-title margin-right-10px">Effectif/Besoin</span>
            </div>
            <div
              class="border-top-grey border-right-grey height-40px"
              [class.background-white]="getDifference($any(item).morning) >= 0"
              [class.background-warning]="getDifference($any(item).morning) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference($any(item).morning) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span class="text-ellipsis bold" [class.margin-left-10px]="getDifference($any(item.morning)) >= 0"
                  >Total</span
                >
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ $any(item).morning.effective }} / {{ $any(item).morning.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference($any(item).morning) >= 0"
                  [class.negative-needs-effectif]="getDifference($any(item).morning) < 0"
                >
                  {{
                    getDifference($any(item).morning) >= 0
                      ? '+' + getDifference($any(item).morning)
                      : getDifference($any(item).morning)
                  }}
                </span>
              </div>
            </div>
            <div
              *ngFor="let population of populationsTotal"
              class="border-top-grey border-right-grey height-40px"
              [class.background-white]="getDifference(population.morning) >= 0"
              [class.background-warning]="getDifference(population.morning) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference(population.morning) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span
                  class="text-ellipsis"
                  [class.margin-left-10px]="getDifference(population.morning) >= 0"
                  [title]="population.name"
                >
                  {{ population.name }}
                </span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ population.morning.effective }} / {{ population.morning.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference(population.morning) >= 0"
                  [class.negative-needs-effectif]="getDifference(population.morning) < 0"
                >
                  {{
                    getDifference(population.morning) >= 0
                      ? '+' + getDifference(population.morning)
                      : getDifference(population.morning)
                  }}
                </span>
              </div>
            </div>
            <div
              *ngFor="let data of item.data"
              class="border-top-grey border-right-grey height-40px"
              [class.background-white]="getDifference($any(data).morning) >= 0"
              [class.background-warning]="getDifference($any(data).morning) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference($any(data).morning) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span
                  class="text-ellipsis"
                  [class.margin-left-10px]="getDifference($any(data).morning) >= 0"
                  [title]="data.title"
                  >{{ data.title }}</span
                >
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ $any(data).morning.effective }} / {{ $any(data).morning.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference($any(data).morning) >= 0"
                  [class.negative-needs-effectif]="getDifference($any(data).morning) < 0"
                >
                  {{
                    getDifference($any(data).morning) >= 0
                      ? '+' + getDifference($any(data).morning)
                      : getDifference($any(data).morning)
                  }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div fxFlex="50">
        <div fxLayout="column">
          <ng-container *ngFor="let item of details">
            <div class="height-28px background-white" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="so-title margin-left-10px">Après-midi</span>
              <span class="so-title margin-right-10px">Effectif/Besoin</span>
            </div>
            <div
              class="border-top-grey height-40px"
              [class.background-white]="getDifference($any(item).afternoon) >= 0"
              [class.background-warning]="getDifference($any(item).afternoon) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference($any(item).afternoon) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span class="text-ellipsis bold" [class.margin-left-10px]="getDifference($any(item).afternoon) >= 0"
                  >Total</span
                >
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ $any(item).afternoon.effective }} / {{ $any(item).afternoon.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference($any(item).afternoon) >= 0"
                  [class.negative-needs-effectif]="getDifference($any(item).afternoon) < 0"
                >
                  {{
                    getDifference($any(item).afternoon) >= 0
                      ? '+' + getDifference($any(item).afternoon)
                      : getDifference($any(item).afternoon)
                  }}
                </span>
              </div>
            </div>
            <div
              *ngFor="let population of populationsTotal"
              class="border-top-grey height-40px"
              [class.background-white]="getDifference(population.afternoon) >= 0"
              [class.background-warning]="getDifference(population.afternoon) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference(population.afternoon) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span
                  class="text-ellipsis"
                  [class.margin-left-10px]="getDifference(population.afternoon) >= 0"
                  [title]="population.name"
                >
                  {{ population.name }}
                </span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ population.afternoon.effective }} / {{ population.afternoon.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference(population.afternoon) >= 0"
                  [class.negative-needs-effectif]="getDifference(population.afternoon) < 0"
                >
                  {{
                    getDifference(population.afternoon) >= 0
                      ? '+' + getDifference(population.afternoon)
                      : getDifference(population.afternoon)
                  }}
                </span>
              </div>
            </div>
            <div
              *ngFor="let data of item.data"
              class="border-top-grey height-40px"
              [class.background-white]="getDifference($any(data).afternoon) >= 0"
              [class.background-warning]="getDifference($any(data).afternoon) < 0"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="getDifference($any(data).afternoon) < 0" class="warning-color margin-left-10px"
                  >warning</mat-icon
                >
                <span
                  class="text-ellipsis"
                  [class.margin-left-10px]="getDifference($any(data).afternoon) >= 0"
                  [title]="data.title"
                  >{{ data.title }}</span
                >
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px"
                  >{{ $any(data).afternoon.effective }} / {{ $any(data).afternoon.needs }}</span
                >
                <span
                  *ngIf="showDifference"
                  class="margin-right-10px margin-top-auto margin-bottom-auto"
                  [class.positive-needs-effectif]="getDifference($any(data).afternoon) >= 0"
                  [class.negative-needs-effectif]="getDifference($any(data).afternoon) < 0"
                >
                  {{
                    getDifference($any(data).afternoon) >= 0
                      ? '+' + getDifference($any(data).afternoon)
                      : getDifference($any(data).afternoon)
                  }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isTVO">
    <div
      class="h-full"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="10px"
      (mouseenter)="onEffectiveNeedsMouseEnter()"
      (mouseleave)="onEffectiveNeedsMouseLeave()"
    >
      <div
        class="min-width-225px nowrap h-full border-grey total-needs-effectif-text"
        fxLayout="row"
        fxLayoutAlign="start center"
      >
        <div
          class="h-full border-right-grey"
          [class.background-white]="!isLoading"
          fxLayout="row"
          fxLayoutAlign="space-around center"
          fxFlex="45"
        >
          <div>
            <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
              <span>Matin :</span>
            </div>
          </div>
          @if (!isLoading) {
            <div>
              <span class="margin-right-10px">{{ $any(roleNeedsTotal).morning }}</span>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>
        <div
          class="h-full"
          [class.background-white]="!isLoading"
          fxLayout="row"
          fxLayoutAlign="space-around center"
          fxFlex="55"
        >
          <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
            <span>Après-midi :</span>
          </div>
          @if (!isLoading) {
            <div>
              <span class="margin-right-10px">{{ $any(roleNeedsTotal).afternoon }}</span>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="loadingDay"></ng-container>
          }
        </div>
      </div>
    </div>

    <div
      *ngIf="!isLoading && roleNeedsTotal"
      class="border-grey width-50vw min-width-440px display-none"
      [class.display-effective-needs-details]="hoverEffectiveNeeds"
      fxLayout="row"
    >
      <div fxFlex="50">
        <div fxLayout="column">
          <ng-container>
            <div
              class="border-right-grey height-28px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <span class="so-title margin-left-10px">Matin</span>
              <span class="so-title margin-right-10px">Besoin</span>
            </div>
            <div
              class="border-top-grey border-right-grey height-40px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="text-ellipsis bold margin-left-10px">Total</span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px">{{ $any(roleNeedsTotal).morning }}</span>
              </div>
            </div>
            <div
              *ngFor="let needsByRole of roleNeedsTotal.needsByRole"
              class="border-top-grey border-right-grey height-40px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="text-ellipsis margin-left-10px" [title]="needsByRole?.role?.name || ''">
                  {{ needsByRole?.role?.name || '' }}
                </span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px">{{ needsByRole.morning }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div fxFlex="50">
        <div fxLayout="column">
          <ng-container>
            <div class="height-28px background-white" fxLayout="row" fxLayoutAlign="space-between center">
              <span class="so-title margin-left-10px">Après-midi</span>
              <span class="so-title margin-right-10px">Besoin</span>
            </div>
            <div
              class="border-top-grey height-40px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="text-ellipsis bold margin-left-10px">Total</span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px">{{ $any(roleNeedsTotal).afternoon }}</span>
              </div>
            </div>
            <div
              *ngFor="let needsByRole of roleNeedsTotal.needsByRole"
              class="border-top-grey height-40px background-white"
              fxLayout="row"
              fxLayoutAlign="space-between center"
            >
              <div fxFlex="65" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="text-ellipsis margin-left-10px" [title]="needsByRole?.role?.name || ''">
                  {{ needsByRole?.role?.name || '' }}
                </span>
              </div>
              <div fxFlex="grow" fxLayout="row" fxLayoutAlign="end center">
                <span class="margin-right-10px">{{ needsByRole.afternoon }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #NIGHT_TEMPLATE>
  @if (isEffectiveNeedsByReasonMaps && dayNeeds !== undefined && dayEffectifs !== undefined) {
    <div [fxLayout]="layout" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="details-button" (click)="openDetailsPopup()" *ngIf="showInformationsButton && !showStatusIconOnly">
        <mat-icon>info_outline</mat-icon>
      </div>

      <div
        *ngIf="!showStatusIconOnly"
        fxLayoutAlign="start center"
        [class.clickable-text]="clickOnTextToOpenDetails"
        class="normal-text"
        fxLayout="row"
        [fxLayoutAlign]="getFxLayoutAlign()"
        (click)="clickOnTextToOpenDetails ? openDetailsPopup() : undefined"
      >
        @if (!minimalistTitle) {
          <div class="bilan">Bilan :&nbsp;</div>
        }
        <div class="bilan">{{ dayEffectifs }} / {{ dayNeeds }}</div>
        <!-- | number: '1.0-0' -->

        @if (showDifference) {
          <div
            class="difference"
            [class.green-text]="dayEffectifs - dayNeeds >= 0"
            [class.red-text]="dayEffectifs - dayNeeds < 0"
          >
            &nbsp; ({{
              dayEffectifs - dayNeeds >= 0
                ? '+' + formatNumber(dayEffectifs - dayNeeds)
                : formatNumber(dayEffectifs - dayNeeds)
            }})
          </div>
        }
      </div>
    </div>
  } @else {
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="details-button" (click)="openDetailsPopup()" *ngIf="showInformationsButton">
        <mat-icon>info_outline</mat-icon>
      </div>

      <div
        *ngIf="!isMensuel"
        class="normal-text"
        [ngClass]="{ 'normal-text-dark': period === 'NIGHT' }"
        fxLayout="column"
        fxLayoutAlign="start center"
      >
        <div fxLayout="row" fxLayoutAlign="start center">
          <div>Total :&nbsp;</div>

          <ng-container *ngIf="!isLoading; else loadingNight">
            <div>{{ $any(nightTotal).effective }} / {{ $any(nightTotal).needs }}</div>
            <div
              class="difference"
              *ngIf="showDifference"
              [class.green-text]="getDifference($any(nightTotal)) >= 0"
              [class.red-text]="getDifference($any(nightTotal)) < 0"
            >
              &nbsp; ({{
                getDifference($any(nightTotal)) >= 0
                  ? '+' + getDifference($any(nightTotal))
                  : getDifference($any(nightTotal))
              }})
            </div>
          </ng-container>
        </div>
      </div>

      <div class="objectif-status-container height-32px" *ngIf="showStatusIcon && !isMensuel">
        <app-objectif-status class="objectif-status" [isLoading]="isLoading" [status]="nightObjectifStatus">
        </app-objectif-status>
      </div>
    </div>
  }
</ng-template>

<ng-template #loadingDay>
  <div fxLayout="row" fxLayoutAlign="start center">
    <div>--</div>
    <div>&nbsp;/&nbsp;</div>
    <div>--{{ showDifference ? ' (--)' : '' }}</div>
  </div>
</ng-template>

<ng-template #loadingNight>
  <div fxLayout="row" fxLayoutAlign="start center">
    <div>--</div>
  </div>
</ng-template>
